import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';

import { Login as LoginBox } from '../components/Query/User';
import { Container, Section, Title } from '../modules/modules';
import CountryService from '../services/CountryService';

interface ILoginProps extends RouteComponentProps<{ language: string }> {
}

class Login extends React.Component<ILoginProps> {

  public render() {
    const { countryCode } = CountryService.GetInstance();

    return (
      <main>
        <Section type="login">
          <Container>
            <div className="login">
              <Title type="textPage">
                Customer sign in
              </Title>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <div className="login__block">
                    <Title type="sub">Sign in</Title>
                    <LoginBox
                      type="page"
                      onLogin={() => this.props.history.push(`/${countryCode}`)}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="login__signIn__description">
                    <Title type="sub">No account?</Title>
                    <p>Signing up will make your future purchases easier - you will not have to enter anything besides your username (e-mail) and password.</p>
                    <Link to={`/${countryCode}/register`}>Create my account now</Link>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Section>
      </main>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.tsx